import {
    CMobileMenu
} from './styled'

export default {
    'mobile-menu-container':CMobileMenu
}
